import React, { useEffect, useState } from "react"

interface MetadataEditorProps {
  manifest: {
    name: string
    description: string
  }
  onSave: (manifest: { name: string; description: string }) => void
  onCancel: () => void
  open: boolean
}

const MetadataEditor: React.FC<MetadataEditorProps> = ({
  manifest,
  onSave,
  onCancel,
  open,
}) => {
  const [editedManifest, setEditedManifest] = useState({
    name: manifest.name || "",
    description: manifest.description || "",
  })

  // Update local state when props change
  useEffect(() => {
    if (open) {
      setEditedManifest({
        name: manifest.name || "",
        description: manifest.description || "",
      })
    }
  }, [manifest, open])

  // Handle input changes
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target
    setEditedManifest((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // Handle save action
  const handleSave = () => {
    onSave(editedManifest)
  }

  if (!open) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-lg">
        <h2 className="text-xl font-semibold text-white mb-4">
          Edit Plugin Metadata
        </h2>

        <div className="mb-4">
          <label className="block text-gray-300 mb-2">Name</label>
          <input
            type="text"
            name="name"
            value={editedManifest.name}
            onChange={handleChange}
            className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
            placeholder="Plugin Name"
          />
        </div>

        <div className="mb-6">
          <label className="block text-gray-300 mb-2">Description</label>
          <textarea
            name="description"
            value={editedManifest.description}
            onChange={handleChange}
            className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white h-32"
            placeholder="Describe what your plugin does..."
          />
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default MetadataEditor
